import { clearDB } from 'Contexts/idb';
import secureStorage from 'hooks/secureStorage';
import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(
    secureStorage.getItem('isAuthenticated') === 'true'
  );

  const [user, setUser] = useState({});

  const login = (userRole, reset_pswd, userInfo) => {
    // Liste des emails bloqués
    const blockedEmails = [
      'api.user@cgeds.com'
    ];

    // Vérifier l'email dans userEmail (qui vient de res?.data?.user)
    const userEmail = userInfo?.email;
    if (userEmail && blockedEmails.includes(userEmail)) {
      secureStorage.removeItem('isAuthenticated');
      // Perform logout operations, e.g., remove the token
      secureStorage.removeItem('usertoken_session');
      secureStorage.removeItem('user_info');
      secureStorage.removeItem('project_tokens');
      secureStorage.removeItem('signature_com_enq');
      secureStorage.removeItem('user_role');
      secureStorage.removeItem('enquete_courante');
      clearDB();
      setIsAuthenticated(false);
      window.location.href = '/';
      return;
    }

    secureStorage.setItem('isAuthenticated', 'true');
    setIsAuthenticated(true);

    // Redirect based on user role using window.location.href
    if (userRole === 'ADMIN' || userRole === 'COT') {
      window.location.href = '/presfor/AdminPresforPage';
      { userRole === 'ADMIN' ? setUser({ userRole: 'ADMIN' }) : setUser({ userRole: 'COT' }) };
    } else if (userRole === 'ENQUETEUR' || userRole === 'CQ' || userRole === 'CD') {
      if (reset_pswd === true) window.location.href = '/psfcprofil';
      else window.location.href = '/accueil-expert';
      // else window.location.href = '/psfcprojets';
      if (userRole === 'ENQUETEUR') {
        setUser({ userRole: 'ENQUETEUR' });
      }
      if (userRole === 'CQ') {
        setUser({ userRole: 'CQ' });
      }
      if (userRole === 'CD') {
        setUser({ userRole: 'CD' });
      }
    } else {
      // Default redirection if role is not recognized
      window.location.href = '/';
    }
  };

  const logout = () => {
    secureStorage.removeItem('isAuthenticated');
    // Perform logout operations, e.g., remove the token
    secureStorage.removeItem('usertoken_session');
    secureStorage.removeItem('user_info');
    secureStorage.removeItem('project_tokens');
    secureStorage.removeItem('signature_com_enq');
    secureStorage.removeItem('user_role');
    secureStorage.removeItem('enquete_courante');
    clearDB();
    // Update isAuthenticated to false
    setIsAuthenticated(false);

    // Redirect to the login page after logout using window.location.href
    window.location.href = '/psfcseconnecter';
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
